import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03af88d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "features" }
const _hoisted_2 = { class: "f-location" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Poznań, Poland", -1))
const _hoisted_4 = { class: "f-yo" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "f-lang-pl" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/polish.svg",
    alt: "Polish language - native"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Natywny")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "f-lang-en" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/english.svg",
    alt: "English language - B1"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "B1")
], -1))
const _hoisted_7 = { class: "contact s-static" }
const _hoisted_8 = { class: "l-static i-features" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.linkedin.com/in/agnieszka-jezierska",
    target: "_blank"
  }, "Linked in")
], -1))
const _hoisted_10 = { class: "c-mail" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:agnieszka.jezierska97@gmail.com",
    target: "_blank"
  }, "Napisz do mnie")
], -1))
const _hoisted_12 = { class: "why-me s-static" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Przepis na testera", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Uszykuj niezbędne komponenty i odważ je na wadze szczegółowości tak, aby finalnie oddały jak najlepszy produkt. Dokładnie pokrój wszystkie składniki i włóż je do kotła wraz z zainfuzjowanym ośmioletnio gastronomią garkotłukiem. Następnie gotuj je do granic ciekawości, do momentu aż wszystkie produkty stworzą zgrany zespół. Bądź odważny w doprawianiu - w końcu to od tego zależy cały smak naszej przyszłej współpracy. ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Moje cechy:", -1))
const _hoisted_16 = { class: "l-static i-features" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, [
  /*#__PURE__*/_createTextVNode("Dokładność "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("w codziennym działaniu")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, [
  /*#__PURE__*/_createTextVNode("Umiejętność "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("logicznego myślenia")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, [
  /*#__PURE__*/_createTextVNode("Przywiązanie"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" do drobiazgów")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, [
  /*#__PURE__*/_createTextVNode("Ścisła wspólpraca"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" w zespole")
], -1))
const _hoisted_21 = { class: "skills s-static" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Moje umiejętności w IT", -1))
const _hoisted_23 = { class: "l-static i-features certs" }
const _hoisted_24 = { class: "-cert" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "-label" }, [
  /*#__PURE__*/_createTextVNode("ISTQB"),
  /*#__PURE__*/_createElementVNode("sup", null, "®"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("small", null, "Foundation")
], -1))
const _hoisted_26 = { class: "l-static i-features" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, [
  /*#__PURE__*/_createTextVNode("Testy manulane "),
  /*#__PURE__*/_createElementVNode("small", null, "(aplikacje WWW)")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, [
  /*#__PURE__*/_createTextVNode("Testy automatyczne "),
  /*#__PURE__*/_createElementVNode("small", null, "(Selenium IDE)")
], -1))
const _hoisted_29 = { class: "nearest-targets s-static" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Cele na najbliższą przyszłość", -1))
const _hoisted_31 = { class: "l-static i-features" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, [
  /*#__PURE__*/_createTextVNode("ISTQB"),
  /*#__PURE__*/_createElementVNode("sup", null, "®"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("small", null, "Agile Tester - 2024")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, [
  /*#__PURE__*/_createTextVNode("Rozwój umiejętności "),
  /*#__PURE__*/_createElementVNode("small", null, "w testach automatycznych")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, [
  /*#__PURE__*/_createTextVNode("Język angielski "),
  /*#__PURE__*/_createElementVNode("small", null, "B2+/C1")
], -1))
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<section class=\"experience s-static\" data-v-03af88d8><h2 data-v-03af88d8>Przebieg mojej kariery</h2><p data-v-03af88d8> We wszystkim co robię liczy się dla mnie nieustanny rozwój oraz chęć odkrywania. Stawianie sobie kolejnych wyzwań to moja codzienność. Gastronomia była moją mekką, gdzie spełniałam się na tle zawodowym. Teraz przyszła pora na kolejne, ogromne wyzwanie. </p><ul data-v-03af88d8><li class=\"e-item\" data-v-03af88d8><span class=\"e-ball\" data-v-03af88d8></span><div class=\"e-content\" data-v-03af88d8><time data-v-03af88d8>2023 - *</time><ul class=\"e-details\" data-v-03af88d8><li data-v-03af88d8><strong data-v-03af88d8>Staż - tester manualny w DMC</strong><br data-v-03af88d8><small data-v-03af88d8>(testy manualne, tworzenie przypadków testowych, podstawowe testy Selenium IDE)</small></li></ul></div></li><li class=\"e-item\" data-v-03af88d8><span class=\"e-ball\" data-v-03af88d8></span><div class=\"e-content\" data-v-03af88d8><time data-v-03af88d8>2015 - 2023</time><ul class=\"e-details\" data-v-03af88d8><li data-v-03af88d8><span data-v-03af88d8>kucharz w “Projekt Alfa”</span></li><li data-v-03af88d8><span data-v-03af88d8>kucharz w “Cykoria”</span></li><li data-v-03af88d8><span data-v-03af88d8>cukiernik w “Veni Andro”</span></li><li data-v-03af88d8><span data-v-03af88d8>cukiernik w “F...ing Delicious”</span></li><li data-v-03af88d8><span data-v-03af88d8>kucharz w “A nóż widelec”</span></li><li data-v-03af88d8><span data-v-03af88d8>cukiernik w “The Time”</span></li><li data-v-03af88d8><span data-v-03af88d8>kucharz w “Troca”</span></li><li data-v-03af88d8><span data-v-03af88d8>kucharz w “Oskoma”</span></li><li data-v-03af88d8><span data-v-03af88d8>pomoc kuchenna w “Avocado”</span></li></ul></div></li><li class=\"e-item\" data-v-03af88d8><span class=\"e-ball\" data-v-03af88d8></span><div class=\"e-content\" data-v-03af88d8><time data-v-03af88d8>2016 - 2017</time><ul class=\"e-details\" data-v-03af88d8><li data-v-03af88d8><span data-v-03af88d8>staż w “Affogato”</span></li><li data-v-03af88d8><span data-v-03af88d8>staż w “Moonsfera”</span></li><li data-v-03af88d8><span data-v-03af88d8>reprezentacja Polski w konkursie “Chefs en Or” jako pomocnik kucharza profesjonalisty w Paryżu</span></li><li data-v-03af88d8><span data-v-03af88d8>liczne konkursy ogólnopolskie i międzyszkolne</span></li><li data-v-03af88d8><span data-v-03af88d8>kurs barmański PBA lvl A</span></li><li data-v-03af88d8><span data-v-03af88d8>kurs baristyczny</span></li></ul></div></li></ul></section>", 1)
const _hoisted_36 = { class: "education s-static" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Edukacja", -1))
const _hoisted_38 = { class: "l-static i-features" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, [
  /*#__PURE__*/_createTextVNode("Zespół Szkół nr 1 w Swarzędzu "),
  /*#__PURE__*/_createElementVNode("small", null, "Specjalizacja: Technik żywienia i usług gastronomicznych")
], -1))
const _hoisted_40 = { class: "about-me s-static" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "O mnie", -1))
const _hoisted_42 = { class: "l-static i-features" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, "Wypieki", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "-label" }, "Gitara", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "-icon",
    src: "/sudoku-icon.png",
    alt: "Sudoku"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "-label" }, "Sudoku")
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "-icon",
    src: "/origami-icon.svg",
    alt: "Origami"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "-label" }, "Origami")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")!
  const _component_icon_component = _resolveComponent("icon-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_component, {
      "top-bg": {
      mobile: '/aga-bg-mobile.jpg',
      desktop: '/aga-bg.jpg',
    },
      avatar: "/avatar-aga.png",
      firstname: "Agnieszka",
      lastname: "Jezierska",
      back: "/"
    }, null, 8, ["top-bg"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_2, [
          _createVNode(_component_icon_component, {
            size: 36,
            icon: _ctx.IconKey.LOCALIZATION
          }, null, 8, ["icon"]),
          _hoisted_3
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_ctx.yearsOld) + " lat", 1)
        ]),
        _hoisted_5,
        _hoisted_6
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.LINKEDIN,
            fill: "#1151b8"
          }, null, 8, ["icon"]),
          _hoisted_9
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.MAIL,
            fill: "#0066ec"
          }, null, 8, ["icon"]),
          _hoisted_11
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _hoisted_13,
      _hoisted_14,
      _hoisted_15,
      _createElementVNode("ul", _hoisted_16, [
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.DIAMOND,
            fill: "#6bbf47"
          }, null, 8, ["icon"]),
          _hoisted_17
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.DIAMOND,
            fill: "#6aa05c"
          }, null, 8, ["icon"]),
          _hoisted_18
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.DIAMOND,
            fill: "#3e863d"
          }, null, 8, ["icon"]),
          _hoisted_19
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.DIAMOND,
            fill: "#225f21"
          }, null, 8, ["icon"]),
          _hoisted_20
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("ul", _hoisted_23, [
        _createElementVNode("li", null, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_icon_component, {
              class: "-icon",
              icon: _ctx.IconKey.CERT,
              fill: "#6bbf47"
            }, null, 8, ["icon"]),
            _hoisted_25
          ])
        ])
      ]),
      _createElementVNode("ul", _hoisted_26, [
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#6bbf47"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#75ad64"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.EMPTY_STAR,
            fill: "#699f5c"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.EMPTY_STAR,
            fill: "#569a4c"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.EMPTY_STAR,
            fill: "#3e863d"
          }, null, 8, ["icon"]),
          _hoisted_27
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#6bbf47"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.EMPTY_STAR,
            fill: "#75ad64"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.EMPTY_STAR,
            fill: "#699f5c"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.EMPTY_STAR,
            fill: "#569a4c"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.EMPTY_STAR,
            fill: "#3e863d"
          }, null, 8, ["icon"]),
          _hoisted_28
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_29, [
      _hoisted_30,
      _createElementVNode("ul", _hoisted_31, [
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.LIGHTBULB,
            fill: "#fea620"
          }, null, 8, ["icon"]),
          _hoisted_32
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.LIGHTBULB,
            fill: "#fea620"
          }, null, 8, ["icon"]),
          _hoisted_33
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.LIGHTBULB,
            fill: "#fea620"
          }, null, 8, ["icon"]),
          _hoisted_34
        ])
      ])
    ]),
    _hoisted_35,
    _createElementVNode("section", _hoisted_36, [
      _hoisted_37,
      _createElementVNode("ul", _hoisted_38, [
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.EDUCATION,
            fill: "#fea620"
          }, null, 8, ["icon"]),
          _hoisted_39
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_40, [
      _hoisted_41,
      _createElementVNode("ul", _hoisted_42, [
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.CAKE
          }, null, 8, ["icon"]),
          _hoisted_43
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            class: "-icon",
            icon: _ctx.IconKey.GUITAR
          }, null, 8, ["icon"]),
          _hoisted_44
        ]),
        _hoisted_45,
        _hoisted_46
      ])
    ])
  ], 64))
}